// extracted by mini-css-extract-plugin
export var cta = "News-module--cta--x+cU3";
export var date = "News-module--date--oHvNz";
export var desc = "News-module--desc--gmON9";
export var large = "News-module--large--sLWs6";
export var root = "News-module--root--Uicm0";
export var title = "News-module--title--Dcbjj";